import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { color, Icon, typography } from '@uniquegood/realworld-studio-design';
import { PrivacyAgreementProps } from '../types';

const PrivacyAgreement = ({ register, error }: PrivacyAgreementProps) => {
  return (
    <PrivacyCard>
      <PrivacyHeader>
        <Icon icon="info_circle_solid" size="24px" css={{ margin: 0 }} />
        <PrivacyTitle>개인정보 수집 및 이용 동의</PrivacyTitle>
      </PrivacyHeader>
      <PrivacyContent>
        <PrivacyText>
          리얼월드 스튜디오 요금제 상담을 위한 개인정보 수집 및 이용 안내
          <OrderedList>
            <li>수집 주체 : 주식회사 유니크굿컴퍼니</li>
            <li>수집 목적 : 서비스 문의 접수 및 상담 안내 등 관련 정보 제공</li>
            <li>수집 항목 : 기업명, 업무용 이메일, 성함, 전화번호</li>
            <li>보관 기간 : 1년</li>
            <ul
              css={css`
                list-style: disc;
              `}
            >
              <li>단, 관계 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관할 수 있습니다.</li>
            </ul>
          </OrderedList>
          <p>
            개인정보 수집 및 이용에 동의하지 않으실 수 있으나, 동의하지 않을 경우 요금제 상담이
            제한될 수 있습니다.
          </p>
        </PrivacyText>
      </PrivacyContent>

      <CheckboxWrapper>
        <Checkbox
          id="privacy-agreement"
          type="checkbox"
          {...register('personalInfoConsent', { required: true })}
        />
        <CheckboxLabel htmlFor="privacy-agreement">약관에 동의합니다.</CheckboxLabel>
        {error && <ErrorText>{error}</ErrorText>}
      </CheckboxWrapper>
    </PrivacyCard>
  );
};

export default PrivacyAgreement;

const PrivacyCard = styled.div`
  background: ${color.white};
  border-radius: 24px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PrivacyHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
`;

const PrivacyContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PrivacyTitle = styled.h3`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${typography.weight.bold};
  color: ${color.text_default};
  margin: 0;
`;

const PrivacyText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #555555;

  p {
    margin: 8px 0;
  }
`;

const OrderedList = styled.ol`
  padding-left: 21px;

  li {
    margin-bottom: 0;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #7800ff;
`;

const CheckboxLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: ${color.text_default};
  cursor: pointer;
`;

const ErrorText = styled.span`
  font-size: 12px;
  color: #ff4444;
  margin-left: 8px;
`;
